import { compose } from "redux";
import { connect } from "react-redux";
import { DatePicker, TimePicker } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
// import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid'
// import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
// import RadioButton from '@material-ui/core/Radio';
// import RadioButtonGroup from '@material-ui/core/RadioGroup';
import React from 'react';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// import { registration } from "../actions/SessionAction";
import { getBookedTime, postBookingTime } from "../actions/BookedAction";
// import { library } from '@fortawesome/fontawesome-svg-core';
import { fetchLibrary } from "../actions/LibraryAction";
import moment from "moment";
// import Card from '@material-ui/core/Card';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
import { Chip } from "@material-ui/core";
import { getbookingTimeSlot } from "../actions/BookingTimeSlotAction";
const { innerWidth } = window;

// const CustomTableCell = withStyles(theme => ({
//     head: {
//         backgroundColor: "#6128be",
//         color: theme.palette.common.white,
//     },
//     body: {
//         fontSize: 14,
//     },
// }))(TableCell);

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const styles = theme => ({
    root: {
        float: 'right',
    },
    paper: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5

    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },
    gradientButton: {
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 350,
        marginTop: -8,
        marginLeft: 8
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 14,
        color: 'rgba(0, 0, 0, 0.87)'
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    formControl: {
        margin: theme.spacing.unit,
        // width: 350,
        marginTop: 0,
        marginLeft: 8
    },
});

class Booking extends React.Component {
    // static contextTypes = {
    //     router: PropTypes.object,
    // }

    constructor() {
        super();
        this.state = {
            open: false,
            library_id: null,
            bookable_id: null,
            day_of_week: '',
            date: null,
            description: '',
            library_id_error: false,
            bookable_id_error: false,
            start_time_error: false,
            end_time_error: false,
            day_of_week_error: false,
            date_error: false,
            libraries: [],
            bookings: [],
            library: null,
            booking: null,
            booked_time: [],
            booking_slot_time: [],
            inavlid_end_time_error: false,
            startDate: new Date(),
            start_time_with_date: null,
            end_time_with_date: null
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.libraries !== props.libraries) {
            return {
                libraries: props.libraries,
            }
        }
        return null;
    }


    componentDidMount() {
        this.props.dispatch(fetchLibrary());
        this.props.dispatch(getBookedTime());
        this.props.dispatch(getbookingTimeSlot());
        this.setState({ bookable_id: this.props.user.parent_ref })
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({
            open: false,
            library_id: null,
            start_time_with_date: null,
            end_time_with_date: null,
            day_of_week: '',
            date: null,
            description: '',
            library_id_error: false,
            start_time_error: false,
            end_time_error: false,
            day_of_week_error: false,
            date_error: false,
            booked_time: [],
            booking_slot_time: [],
            inavlid_end_time_error: false
        });
    };

    submitForm = () => {

        // let start_time = new Date(this.state.date + " " + this.state.start_time)
        // let end_time = new Date(this.state.date + " " + this.state.end_time)

        // this.setState({ start_time : moment(start_time). format(), end_time : moment(end_time). format()})
        let isError = false;

        if (this.state.library_id === null) {
            this.setState({ library_id_error: true })
            isError = true
        }
        if (this.state.date === null) {
            this.setState({ date_error: true })
            isError = true
        }
        //  else {
        //     this.setState({ date_error: this.state.date < new Date() && true })
        //     isError = true
        // }

        if (this.state.start_time_with_date === null) {
            this.setState({ start_time_error: true })
            isError = true
        }
        if (this.state.end_time_with_date === null) {
            this.setState({ end_time_error: true })
            isError = true
        }

        
        if (this.state.booking_slot_time.length === 0) {
            // this.setState({ end_time_error: true })
            isError = true
        } else {
            isError = this.state.booking_slot_time[0].status !== "ACTIVE" && true 
        }

        if ((this.state.end_time_with_date < this.state.start_time_with_date)) {
            this.setState({ inavlid_end_time_error: true })
            isError = true
        }

        if (isError === false) {
            let booking = {}
            booking.start_time = this.state.start_time_with_date !== undefined ? moment(this.state.start_time_with_date).format() : null
            booking.end_time = this.state.end_time_with_date !== undefined ? moment(this.state.end_time_with_date).format() : null
            booking.library_id = this.state.library_id
            booking.bookable_id = this.state.bookable_id
            booking.day_of_week = this.state.day_of_week
            booking.date = this.state.date
            booking.booking_for = 'team'
            booking.description = this.state.description
            this.props.dispatch(postBookingTime(this, booking))
            this.setState({
                open: false,
                library_id: null,
                start_time_with_date: null,
                end_time_with_date: null,
                day_of_week: '',
                date: null,
                description: '',
                library_id_error: false,
                bookable_id_error: false,
                start_time_error: false,
                end_time_error: false,
                day_of_week_error: false,
                date_error: false,
                booked_time: [],
                booking_slot_time: [],
                inavlid_end_time_error: false
            })
        }
    }
    dateChange = date => {
        let day_of_week = moment(date).format("dddd")
        let booked_times = (this.props.bookedTimes.length > 0 ? this.props.bookedTimes.filter(time => (moment(time.date).format('MMDDYYYY') === moment(date).format('MMDDYYYY')) && (time.library_id === this.state.library_id)) : [])
        let booking_slot_time = (this.props.bookingTimeSlot.length > 0 ? this.props.bookingTimeSlot.filter(time => (time.day_of_week === day_of_week) && (time.library_id === this.state.library_id)) : [])
        this.setState({ date: date,start_time_with_date: date, end_time_with_date: date, day_of_week: day_of_week, booked_time: booked_times, booking_slot_time: booking_slot_time, date_error: false })
    }
    libraryChange = event => {
        let booked_times = (this.props.bookedTimes.length > 0 ? this.props.bookedTimes.filter(time => (moment(time.date).format('MMDDYYYY') === moment(this.state.date).format('MMDDYYYY')) && (time.library_id === event.target.value)) : [])
        let booking_slot_time = (this.props.bookingTimeSlot.length > 0 ? this.props.bookingTimeSlot.filter(time => (time.day_of_week === this.state.day_of_week) && (time.library_id === event.target.value)) : [])
        this.setState({ library_id : event.target.value, booked_time: booked_times, booking_slot_time: booking_slot_time, library_id_error: false })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={this.handleOpen}> BOOK A SESSION</Button>
                {/* <Card style={{ marginTop: 60 }}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <CustomTableCell>Library Name</CustomTableCell>
                                <CustomTableCell align="left">Date</CustomTableCell>
                                <CustomTableCell align="left">Time</CustomTableCell>
                                <CustomTableCell align="left">Action</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.bookedTimes.length > 0 ?
                            this.props.bookedTimes.map( time => 
                            <TableRow className={classes.row} >
                                <CustomTableCell component="th" scope="row"> </CustomTableCell>
                                <CustomTableCell align="left">{time.date} </CustomTableCell>
                                <CustomTableCell align="left">Start Time: {moment(time.start_time).format('LT')}, End Time: {moment(time.end_time).format('LT')} </CustomTableCell>
                                <CustomTableCell align="left"> </CustomTableCell>
                            </TableRow>)
                            : null }
                        </TableBody>
                    </Table>
                </Card> */}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" style={{ marginBottom: 20 }} >
                            Bookings
                            {this.state.booking_slot_time.length > 0 ?
                                this.state.booking_slot_time[0].status === "ACTIVE" ?
                                    <Typography style={{ float: "right", color: "green" }}>Library open time:
                                {/* {this.state.booking_slot_time[0].start_time} - {this.state.booking_slot_time[0].end_time} */}
                                        {moment(this.state.booking_slot_time[0].start_time, "hh:mm:ss").format('LT')} - {moment(this.state.booking_slot_time[0].end_time, "hh:mm:ss").format('LT')}
                                    </Typography> :
                                    <Typography style={{ float: "right", color: "red" }}> Library closed</Typography> :
                                (this.state.date !== null && this.state.library_id !== null) ? this.state.booking_slot_time.length === 0 && (<Typography style={{ float: "right", color: "red" }}> There is no library schedule for the day</Typography>) : null
                            }
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={6} >
                                <form>
                                    <FormControl className={classes.formControl} fullWidth>
                                        <InputLabel style={{fontSize: '1.3rem'}} required shrink htmlFor="library_name" error={this.state.library_id_error === true ? true : false} >Library Name</InputLabel>
                                        <Select
                                            required
                                            error={this.state.library_id_error === true ? true : false}
                                            value={this.state.library_id || ""}
                                            onChange={this.libraryChange}
                                            fullWidth
                                            inputProps={{
                                                name: 'Library Name',
                                                id: 'library_name',
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                                FormLabelClasses: {
                                                    root: classes.labelRoot
                                                }
                                            }}
                                        >

                                            {this.state.libraries.length > 0 && this.state.libraries.map(library => (
                                                <MenuItem key={library.id} value={library.id}>{library.library_name}</MenuItem>
                                            ))}

                                            {
                                                this.state.libraries.length === 0 &&
                                                <MenuItem key={0} value={0}>{`Select Library`}</MenuItem>
                                            }

                                        </Select>
                                        <FormHelperText error> {this.state.library_id_error === true ? "Please Select Library" : false} </FormHelperText>
                                    </FormControl>
                                </form>
                            </Grid>
                            <Grid item xs={6} >
                                <DatePicker
                                    id="standard-name"
                                    label=" Date"
                                    // type="date"
                                    fullWidth
                                    className={classes.textField}
                                    required
                                    error={this.state.date_error === true ? true : false}
                                    helperText={this.state.date_error === true ? "Please Enter Date" : false}
                                    value={this.state.date }
                                    onChange={this.dateChange}
                                    margin="normal"
                                    disablePast={true}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            {this.state.booked_time.length > 0 ?
                                <Grid item xs={12}>
                                    {this.state.booked_time.length === 1 ? this.state.booked_time[0].status !== "REJECTED" ?
                                        <Typography style={{ marginLeft: 10, marginTop: -17 }}>Booked Time Slots : </Typography>
                                        : null
                                        : <Typography style={{ marginLeft: 10, marginTop: -17 }}>Booked Time Slots : </Typography>}
                                    <Grid container>
                                        {this.state.booked_time.map(time =>
                                            time.status !== "REJECTED" ?
                                                <Grid item xs={3} style={{ margin: 10 }}>
                                                    <Chip
                                                        label={`${moment(time.start_time).format('LT')} - ${moment(time.end_time).format('LT')}`}
                                                        style={{ color: time.status === "ACTIVE" ? "red" : time.status === "REQUESTED" ? "orange" : "#000", borderColor: time.status === "ACTIVE" ? "red" : time.status === "REQUESTED" ? "orange" : "#000" }}
                                                        variant="outlined"
                                                    />
                                                </Grid> : null)}
                                    </Grid>
                                </Grid> : null}
                            <Grid item xs={6} >
                                <TimePicker
                                    id="time"
                                    label="Start Time"
                                    // type="time"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.start_time_with_date}
                                    onChange={(time) => this.setState({start_time_with_date: time, start_time_error: false}) }
                                    // onChange={(event) => this.setState({ start_time: event.target.value, start_time_error: false })} 
                                    helperText={this.state.start_time_error === true ? "Please enter start time" : false}
                                    error={this.state.start_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TimePicker
                                    id="time"
                                    label="End Time"
                                    // type="time"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.end_time_with_date}
                                    onChange={(time) => this.setState({ end_time_with_date: time, end_time_error: false, inavlid_end_time_error: false })}
                                    helperText={this.state.end_time_error === true ? "Please enter end time" : this.state.inavlid_end_time_error === true ? "Please enter valid time" : null}
                                    error={this.state.end_time_error === true ? true : this.state.inavlid_end_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    inputProps={{
                                        step: 300,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    id="standard-name"
                                    label="Description"
                                    style={{ marginTop: 8 }}
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.description || ""}
                                    onChange={(event) => this.setState({ description: event.target.value, })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={this.submitForm} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Modal>
            </div>
        );
    }
}

Booking.propTypes = {
    classes: PropTypes.object.isRequired,

};

const mapStateToProps = (state) => {
    return {
        user: state.SessionReducer.user,
        bookedTimes: state.BookedReducer.bookedTimes,
        libraries: state.LibraryReducer.approvedLibraries,
        myTeam: state.TeamReducer.myTeam,
        bookingTimeSlot: state.BookingTimeSlotReducer.bookingTimeSlot
    }
}

export default compose(withStyles(styles), connect(mapStateToProps))(Booking);